module.exports = __webpack_public_path__ + "static/media/a4c-plan.d171edc4.png";